import { render, staticRenderFns } from "./feedback_hub.vue?vue&type=template&id=beb61e1c&scoped=true&"
import script from "./feedback_hub.vue?vue&type=script&lang=js&"
export * from "./feedback_hub.vue?vue&type=script&lang=js&"
import style0 from "./feedback_hub.vue?vue&type=style&index=0&id=beb61e1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb61e1c",
  null
  
)

export default component.exports